import type { BookingRequest } from '@/api/pending'

/** Payment methods: API code (sent to the backend) + pt-BR label (shown to the reviewer). */
export const PAY_METHODS = [
  { code: 'pix', label: 'Pix' },
  { code: 'transfer', label: 'Transferência' },
  { code: 'boleto', label: 'Boleto' },
  { code: 'cash', label: 'Dinheiro' },
] as const

export const PAY_METHOD_LABEL: Record<string, string> = Object.fromEntries(
  PAY_METHODS.map((m) => [m.code, m.label]),
)

/** Reject reasons: API code (sent to the backend) + pt-BR label (shown to the reviewer/resident). */
export const REJECT_REASONS = [
  { code: 'payment_not_confirmed', label: 'Pagamento não confirmado' },
  { code: 'slot_unavailable', label: 'Horário indisponível' },
  { code: 'incomplete_info', label: 'Informações incompletas' },
  { code: 'other', label: 'Outro motivo' },
] as const

export const REJECT_REASON_LABEL: Record<string, string> = Object.fromEntries(
  REJECT_REASONS.map((r) => [r.code, r.label]),
)

export interface ReviewDraft {
  details: boolean
  hasProof: boolean
  method: string | null
}

/** What still blocks approval. Contact is optional; proof and method only for paid areas. */
export function missingSteps(fee: number, d: ReviewDraft): string[] {
  const m: string[] = []
  if (!d.details) m.push('conferir os detalhes')
  if (fee > 0 && !d.hasProof) m.push('anexar o comprovante')
  if (fee > 0 && !d.method) m.push('informar a forma de pagamento')
  return m
}

/** "Para aprovar, falta conferir os detalhes, anexar o comprovante e informar a forma de pagamento." */
export function missingHint(missing: string[]): string {
  return `Para aprovar, falta ${missing.join(', ').replace(/, ([^,]*)$/, ' e $1')}.`
}

export const STATUS_PILL = {
  pending: { tone: 'pending', label: 'Pendente' },
  approved: { tone: 'approved', label: 'Aprovada' },
  rejected: { tone: 'rejected', label: 'Recusada' },
  cancelled: { tone: 'neutral', label: 'Cancelada' },
} as const satisfies Record<BookingRequest['status'], { tone: string; label: string }>

/** `+55 11 99988-1010` to `5511999881010`, for tel: and wa.me. */
export const phoneDigits = (phone: string) => phone.replace(/\D/g, '')
